<template>
  <div class="stats-player">
    <div
      class="headerline"
      :style="{ background: headType === '2' ? '#c09fcd' : '' }"
    ></div>
    <div class="stats-schedule">
      <!-- pull down start -->
      <div class="pulldown" :class="{ 'option-f': headType === '2' }">
        <!-- -------------boy star---------------- -->
        <!-- schedule -->
        <el-select
          v-if="
            headType == '1' &&
              (selected.value == 2021 || selected.value == 2020)
          "
          :no-data-text="$t('home.loading')"
          :popper-append-to-body="false"
          v-model="selected.value1"
          :placeholder="$t('stats.match')"
          @change="getTableData"
        >
          <el-option
            v-for="item in match"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            <span style="float: left">{{ item.label }}</span>
          </el-option>
        </el-select>
        <!-- -------------boy stop--------------- -->
        <!-- -------girl start----------->
        <!-- schedule -->
        <el-select
          v-if="headType == '2'"
          :no-data-text="$t('home.loading')"
          :popper-append-to-body="false"
          v-model="selected.value1_girl"
          :placeholder="$t('stats.match')"
          @change="getTableData"
        >
          <el-option
            v-for="item in match"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            <span style="float: left">{{ item.label }}</span>
          </el-option>
        </el-select>
        <!-- -----------girl stop------------ -->
        <!-- team -->
        <el-select
          :no-data-text="$t('home.loading')"
          :popper-append-to-body="false"
          v-model="selected.value4"
          :placeholder="$t('stats.team')"
          @change="getTableData"
        >
          <el-option
            v-for="(item, index) in team"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
            <span style="display:block;text-align:left;">{{ item.label }}</span>
          </el-option>
        </el-select>
        <!-- filter -->
        <el-select
          :popper-append-to-body="false"
          v-model="selected.value2"
          :placeholder="$t('stats.filter')"
          @change="getTableData1(selected.value2)"
        >
          <el-option
            v-for="item in filter"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          >
            <span style="float: left">{{ item.label }}</span>
          </el-option>
        </el-select>
        <div class="pull search" style="margin-top: 20px">
          <el-input
            :placeholder="$t('stats.search')"
            v-model="selected.value3"
            @input="changeInput1"
          >
            <el-button slot="append" @click="changeInput">
              <span :style="{ color: headType === '2' ? '#c09fcd' : '' }"
                ><i class="el-icon-search"></i
              ></span>
            </el-button>
          </el-input>
        </div>
      </div>
      <!-- pull down stop -->

      <!-- stats list start -->
      <div style="margin:70px 20px; 0px 20px">
        <template>
          <el-table
            max-height="600px"
            v-loading="statsLoading"
            stripe
            :empty-text="$t('home.nodata')"
            :class="headType === '1' ? 'is-el-table' : 'is-el-table-girl'"
            :data="tableData"
            border
          >
            <el-table-column width="160px" fixed label="PLAYER">
              <template slot-scope="scope">
                <div class="pic-con">
                  <img
                    width="40px"
                    height="40px"
                    :src="scope.row.team_member.temp_icon_path_url"
                    alt=""
                  />

                  <span
                    :style="{ color: headType === '2' ? '#8A5D9D' : '#318bc8' }"
                    class="player-name"
                    >{{ scope.row.team_member.name }}</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column width="120px" label="TEAM">
              <template slot-scope="scope">
                <div class="player-team">
                  {{ scope.row.team_member.team_name }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              sortable
              v-for="(item, index) in statsHeader"
              :prop="item.value"
              :key="index"
            >
              <template slot="header">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.full_title"
                  placement="top"
                >
                  <span
                    class="table-header"
                    style="display:block;text-align:center;"
                    >{{ item.label }}</span
                  >
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <!-- stats list stop -->
    </div>
  </div>
</template>

<script>
import { BasketballApi } from '../../../api/basketball'
import { mapState } from 'vuex'
import statsHeader from '../../../commen/commen_title'
import filter from '../../../commen/commen_title'

function compare(property) {
  return function(a, b) {
    var value1 = a[property]
    var value2 = b[property]
    return value2 - value1
  }
}
export default {
  mixins: [statsHeader, filter],
  props: ['isyear', 'tabName'],
  data() {
    return {
      teamsLoding: true,
      statsLoading: true,
      selected: {
        value: '2021',
        value1: 2,
        value_girl: '2021',
        value1_girl: 10,
        value2: '',
        value3: '',
        value4: '',
      },
      year: [
        {
          label: '2019',
          value: '2019',
        },
        {
          label: '2020',
          value: '2020',
        },
        {
          label: '2021',
          value: '2021',
        },
      ],
      team: [],
      match: [],
      // 表格数据
      tableData: [],
      watchImg: window.localStorage.getItem('watchImg') || 0,
      yearId: 2021,
      album: 's',
    }
  },
  watch: {
    headType() {
      this.getTableData()
      this.getScheduleAlbum()
      this.getTeams()
    },
    isyear(value) {
      if (value && this.tabName == 'tab1') {
        // this.yearId = value
        this.getYear(value)
      }
    },
  },
  computed: {
    ...mapState(['headType']),
    years() {
      return this.headType == '1' ? this.year : this.year.slice(2, 3)
    },
    values: {
      get() {
        return this.headType == '1'
          ? this.selected.value
          : this.selected.value == 2021
      },
      set(newValue) {
        return newValue
      },
    },
    valueGame: {
      get() {
        return this.headType == '1'
          ? this.selected.value1
          : this.selected.value1_girl == 10
      },
      set(newValue) {
        return newValue
      },
    },
  },
  methods: {
    sortData(item) {
      this.tableData.sort(compare(item))
    },
    getYear(item) {
      this.yearId = item
      this.getTeams()
      this.selected.value4 = ''
      this.headType == '1'
        ? (this.selected.value1 = 2)
        : (this.selected.value1_girl = 10)
      this.getTableData()
      this.getScheduleAlbum()
    },
    getTableData1(value) {
      if (value != '') {
        this.tableData.sort(compare(value))
      }
    },
    changeInput1(value) {
      if (value == '') {
        this.getTableData()
      }
    },
    changeInput() {
      if (this.selected.value3 != '') {
        let arr = this.tableData.filter((item) => {
          return item.team_member.name.indexOf(this.selected.value3) >= 0
        })
        this.tableData = arr
      } else {
        this.getTableData()
      }
    },
    // 获取球员数据
    getTableData() {
      this.statsLoading = true
      BasketballApi.getTeamMemberSchedule(
        this.headType == '1' ? this.selected.value1 : this.selected.value1_girl,
        this.isyear,
        this.selected.value4 == 'all' ? '' : this.selected.value4,
        this.headType === '1' ? 'm' : 'w'
      ).then((res) => {
        this.tableData = res
        this.statsLoading = false
      })
    },
    //獲取賽程分類
    getScheduleAlbum() {
      BasketballApi.getScheduleAlbum(
        this.headType == '1' ? 'm' : 'w',
        this.isyear,
        this.album
      ).then((res) => {
        let arr = []
        res.forEach((item) => {
          let obj = new Object()
          obj.value = item.id
          obj.label = item.name
          arr.push(obj)
        })

        this.match = arr
      })
    },
    getTeams() {
      BasketballApi.getTeams({
        year: this.isyear,
        type: this.headType === '1' ? 'm' : 'w',
      }).then((res) => {
        let arr = [
          {
            label: this.$t('home.alldata'),
            value: 'all',
          },
        ]
        res.forEach((item) => {
          let obj = new Object()
          obj.value = item.id
          obj.label = item.name
          arr.push(obj)
        })
        this.team = arr
      })
    },
    tabChange() {
      this.getTableData()
      this.getTeams()
      this.getScheduleAlbum()
    },
  },
  created() {
    // if (this.tabName == 'tab1') {
    //   this.tabChange()
    // }
  },
  mounted() {},
}
</script>
<style lang="scss">
.search {
  .el-input {
    position: relative;
    .el-input__inner {
      border-radius: 20px;
      background: #c5cfe32a;
      border: none;
    }
    .el-input-group__append {
      position: absolute;
      right: 15px;
      top: 10px;
      border: none;
      color: #318bc8;
    }
  }
}

.el-select-dropdown {
  .popper__arrow {
    display: none;
  }
}
.stats-player {
  .stats-schedule {
    .pulldown {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: space-around;
      .el-select {
        margin-top: 20px;
        width: 20%;
        border: none;
        .el-input {
          .el-input__inner {
            border: none;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.nodata {
  margin-top: 30px;
  .coming {
    height: 300px;
    line-height: 300px;
    font-size: 70px;
    color: #e1e5eb;
  }
}

.searchInput {
  border: none;
  width: 100%;
  height: 100%;
  outline: none;
  padding: 0 20px;
}
.stats-player {
  .headerline {
    height: 5px;
    width: 100%;
    background: #318bc8;
    // border-left: 3px solid #fff;
  }
  .stats-schedule {
    .pulldown {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: space-around;
      margin-top: 20px;
      .el-select {
        margin-top: 20px;
        width: 17%;
        border: none;
        border-bottom: 3px solid #c5cfe348;
        .el-option {
          .el-input {
            .el-input__inner {
              border: none !important;
            }
          }
        }
      }
    }
    .pic-con {
      padding: 0 10px;
      width: 100%;
      display: flex;
      align-items: center;
      height: 60px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 2px solid #c5cfe348;
        margin-right: 7px;
        object-fit: cover;
        object-position: top;
      }
      .player-name {
        text-align: left;
        text-overflow: ellipsis;
        white-space: normal;
        word-break: break-word;
      }
    }
    // .stats-list {
    //   margin-top: 70px;
    //   width: 100%;
    //   table {
    //     width: 100%;
    //     border-collapse: collapse;
    //     box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    //     .list-head {
    //       background-color: #037ab9be;
    //       color: #fff;
    //       height: 60px;
    //       cursor: pointer;
    //     }
    //     .list-head:hover {
    //       background: rgb(158, 157, 157) !important;
    //     }
    //   }
    //   td {
    //     background: rgba(255, 255, 255, 0.514);
    //   }
    //   tbody {
    //     tr {
    //       transition: all 0.6s;
    //     }
    //     .player-id {
    //       color: #5aa2d3;
    //       padding: 0 10px;
    //       font-weight: 600;
    //     }
    //     .player-pic {
    //       width: 11%;
    //       color: #5aa2d3;
    //       font-weight: 600;
    //       border-right: 2px solid #e1e5eb;
    //       padding-left: 20px;
    //     }
    //     .player-team {
    //       width: 9%;
    //       padding: 0 15px;
    //     }
    //   }
    //   tbody tr:nth-child(2n) {
    //     background-color: #eaeef6;
    //   }
    //   tbody tr:hover {
    //     background: #73c4e9;
    //     transform: scale(1.01);
    //   }
    //   tbody .tr_girl:hover {
    //     background: #d99ddb;
    //   }
    // }
  }
}
@media screen and (max-width: 768px) {
  .stats-player {
    .stats-schedule {
      .pulldown {
        flex-direction: column;
        height: auto;
        .el-select,
        .search {
          width: 70%;
          margin-left: 15%;
        }
      }
      // .stats-list {
      //   overflow-x: scroll;
      //   table {
      //     width: 1660px;
      //     thead,
      //     tbody {
      //       width: 1660px;
      //     }
      //     thead {
      //       background: #5aa2d3;
      //     }
      //   }
      // }
    }
  }
}
</style>
